module.exports = __webpack_public_path__ + "static/scale-model-of-jellyfish-touch-tank-in-long-beach-california-4fc49bd806d30ddf166c153244361729.png";